import { render, staticRenderFns } from "./MessagesIcon.vue?vue&type=template&id=66761dda&"
import script from "./MessagesIcon.vue?vue&type=script&lang=js&"
export * from "./MessagesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports